export const root = 'lapidary-avatar-list'

export const selectors = { inactive: `${root}-inactive`, root } as const
export const cssVariables = {
  blockSize: `--${root}-block-size`,
  overlapAmount: `--${root}-overlap-amount`,
} as const
export const parts = {
  overflow: 'overflow',
  singleAvatarLabel: 'single-avatar-label',
} as const
